import { getDrawings } from '../../api';
import addDrawingLayer from '../../map/map-layer-manager/drawings-utils/drawing-layer-handler';
import MapHelpers from '../../map/map.utils';
import { Drawing, DrawingShape } from '../../models/drawings.model';
import { setDrawings, setError } from '../../state/drawings/drawings.slice';
import store from '../../store';
import GeoHelper from '../../utils/geo-helpers.utils';
import { convertKmToNauticalMiles } from '../../utils/measurement-helpers';

export const updateDrawings = async () =>
  getDrawings()
    .then((fetchedDrawings) => {
      fetchedDrawings.forEach((drawing) => {
        addDrawingLayer(drawing.region_id, drawing.region_data);
      });

      store.dispatch(setDrawings(fetchedDrawings));
    })
    .catch(() => {
      store.dispatch(setError());
    });

export const goToDrawing = (drawing: Drawing) => {
  const geojson =
    drawing.region_data.properties?.subType === DrawingShape.Circle
      ? GeoHelper.convertFeatureCircleToPolygon(
          drawing.region_data as GeoJSON.Feature<GeoJSON.Point>
        )
      : drawing.region_data;

  // if the drawingShape is Point, the zoom-to continues infinitely
  const options =
    drawing.region_data.geometry?.type === DrawingShape.Point
      ? { maxZoom: 6 }
      : undefined;

  MapHelpers.zoomToFeatureCollection(geojson, options);
  MapHelpers.setLayerVisibility(drawing.region_id, false);
};

// handles converting the radius within a circle drawing km to NM
export const convertKmRadiusToNauticalMiles = (drawing: Drawing): Drawing => {
  if (
    drawing.region_data.properties?.subType === DrawingShape.Circle &&
    drawing.region_data.properties?.radius
  ) {
    const updatedDrawing = {
      ...drawing,
      region_data: {
        ...drawing.region_data,
        properties: {
          ...drawing.region_data.properties,
          radius: convertKmToNauticalMiles(
            drawing.region_data.properties.radius
          ),
        },
      },
    };
    return updatedDrawing;
  }
  return drawing;
};
